export const get = (opt) => request(opt);
